'use client'

import moment, { Moment } from "moment"
import useSWR from "swr"

export type DuneQueryResult = Record<string, string | number> & {
    date: Moment,
}

interface UseQueryResultsProps {
    id: number,
    sampling?: number
}

const DEFAULT_PROPS: Partial<UseQueryResultsProps> = {
    sampling: 1
}

async function fetcher(url: string): Promise<DuneQueryResult[]> {
    return fetch(url, {next: {revalidate: 3600}})
        .then(d => d.json() as Promise<any[]>)
        .then(d => d.map(k => {
            const data = JSON.parse(k.data)
            return {
                    ...data,
                    date: moment.unix(parseInt(k.date_unix)).utc(),
            }
        }
    ))
} 

export function useQueryResults({id, sampling}: UseQueryResultsProps) {
    const uri = `/data/${id}`
    const { data } = useSWR(uri, fetcher)
    
    const processed = data || []

    return { results: processed }
}

export function useSkyOverviewResults() {
    const uri = `/data/sky/token-overview`
    const { data } = useSWR(uri, fetcher)
    
    const processed = data || []

    return { results: processed }
}

interface SankeyResults {
    nodes: {name: string, depth: number}[]
    links: {source: string, target: string, value: number}[]
}

async function sankeyFetcher(url: string): Promise<DuneQueryResult[]> {
    return fetch(url, {next: {revalidate: 3600}})
        .then(d => d.json() as Promise<any[]>)
} 

export function useSankeyData({id, pivot}: {id: number, pivot: string}): {results: SankeyResults} {
    const uri = `/data/${id}/sankey_data?pivot=${pivot}`
    const { data } = useSWR(uri, sankeyFetcher)
    
    const processed = data as unknown as SankeyResults || {nodes: [], links: []}

    return { results: processed }
}

export interface HoldingsByTagPoint {
    day: string
    tag: string
    balance: string
}

export interface HoldingsByTagResponse {
    token_address: string
    series: HoldingsByTagPoint[]
}

async function collectFetcher<T>(url: string): Promise<T> {
    return fetch(url, {next: {revalidate: 3600}}).then(d => d.json() as Promise<T>)
}

export function useTokenHoldingsByTag({token}: {token: string}): {results: HoldingsByTagPoint[], tokenAddress?: string} {
    const uri = `/data/collect/tokens/${token}/holdings-by-tag-historical`
    console.log(uri)
    const { data } = useSWR(uri, collectFetcher<HoldingsByTagResponse>)

    return {
        results: data?.series ?? [],
        tokenAddress: data?.token_address
    }
}
